export const APPLICATIONS_API = `/api/v1/applications`;
